import { device } from "@src/theme";
import React from "react";
import styled from "styled-components";

const DrawerContainer = styled.div<{
  $isClosed: boolean;
  $floatingDrawer?: boolean;
  maxWidth?: string;
  minWidth?: string;
  height?: string;
}>`
  width: 100%;
  max-width: ${({ maxWidth }): string => maxWidth || "480px"};
  min-width: ${({ minWidth }): string => minWidth || "480px"};
  background-color: ${({ theme }): string => theme.colors.gray300};
  display: inline-block;
  position: fixed;
  position: ${({ $isClosed, $floatingDrawer }): string =>
    $floatingDrawer ? "absolute" : $isClosed ? "absolute" : "relative"};
  z-index: 99;
  box-shadow: ${({ $isClosed }): string =>
    $isClosed ? "none" : "0px 0px 10px rgba(0, 0, 0, 0.5)"};
  transition: transform 0.3s ease;
  transform: ${({ $isClosed }): string =>
    $isClosed ? "translateX(-200%)" : "translateX(0)"};
  display: flex;
  flex-direction: column;
  min-width: ${({ minWidth }): string => minWidth || "480px"};
  height: ${({ height }): string => height || "calc(100vh - 235px)"};
`;
// height: calc(100vh - 235px);

const DrawerContent = styled.div<{
  noPadding?: boolean;
  hasDrawerHeader?: boolean;
}>`
  padding: ${({ theme, noPadding }): string =>
    noPadding ? "0" : theme.margins.large};
  padding-top: ${({ hasDrawerHeader, theme, noPadding }): string =>
    noPadding ? "0" : hasDrawerHeader ? "0" : theme.margins.large};
  overflow-y: auto;
  overflow-x: hidden;
  flex: 1 1 auto;
  max-height: 100%;

  @media ${device.tablet} {
    padding: ${({ theme, noPadding }): string =>
      noPadding ? "0" : theme.margins.medium};
  }
  @media ${device.mobile} {
    padding: ${({ theme, noPadding }): string =>
      noPadding ? "0" : theme.margins.small};
  }
`;

const DrawerHeader = styled.div`
  padding: ${({ theme }): string => theme.margins.large};
  flex-shrink: 0;

  @media ${device.tablet} {
    padding: ${({ theme }): string => theme.margins.medium};
  }
  @media ${device.mobile} {
    padding: ${({ theme }): string => theme.margins.large};
  }
`;

type ContentDrawerProps = {
  children?: React.ReactNode;
  isOpen: boolean;
  toggleDrawer: () => void;
  $floatingDrawer?: boolean;
  customHeight?: string;

  maxWidth?: string;
  minWidth?: string;
  drawerHeader?: React.ReactNode;
  noContentPadding?: boolean;
};

const ContentDrawer = ({
  children,
  isOpen,
  $floatingDrawer,
  maxWidth = "480px",
  minWidth = "480px",
  drawerHeader,
  noContentPadding,
  customHeight,
}: ContentDrawerProps): React.JSX.Element => {
  return (
    <DrawerContainer
      height={customHeight}
      maxWidth={maxWidth}
      minWidth={minWidth}
      $floatingDrawer={$floatingDrawer}
      $isClosed={!isOpen}
    >
      {drawerHeader && <DrawerHeader>{drawerHeader}</DrawerHeader>}
      <DrawerContent
        noPadding={!!noContentPadding}
        hasDrawerHeader={!!drawerHeader}
        className="scrollbar-style-2"
      >
        {children}
      </DrawerContent>
    </DrawerContainer>
  );
};

export default ContentDrawer;
